import React, { useRef, useState } from 'react';
import './ModalTableBox.scss';
import { TableBox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../ModalComponent/ModalComponent';

const ModalTableBox = ({
  onClose,
  tableProps,
  onAddProductToAction,
  setCheckedProducts,
  onAddProducts,
  setIsPromoModalOpen,
}) => {
  const paginatorRef = useRef();

  return (
    <ModalComponent
      title='Таблица товаров'
      onClose={onClose}
      child={
        <div className="modal_csv_container">
          <TableBox
            {...tableProps}
            paginator={true}
            ref={paginatorRef}
            onCheck={(e) => {
              setCheckedProducts(e);
            }}
            // onUncheckAllDependence={[pageValue, currentDiscount, productAction]}
            child={
              <>
                <ButtonBasic
                  action
                  width="180px"
                  maxWidth="180px"
                  text={'Добавить выбранные'}
                  size="32px"
                  // disabled={!checkedProducts.length}
                  onClick={() => {
                    onAddProductToAction();
                    onClose();
                    setIsPromoModalOpen();
                  }}
                />
                <ButtonBasic
                  action
                  width="180px"
                  maxWidth="180px"
                  text={'Добавить все'}
                  size="32px"
                  // disabled={!checkedProducts.length}
                  onClick={() => {
                    onAddProducts();
                    onClose();
                    setIsPromoModalOpen();
                  }}
                />
              </>
            }
          />
        </div>
      }
    />
  );
};

export default ModalTableBox;
